export default __webpack_public_path__ + "static/media/pdf.9dc0464e.svg";